<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="true"
        :is-full-page="true"
    ></b-loading>
    <preview-modal ref="previewModal"></preview-modal>
    <div class="columns">
      <div class="column">
        <div>
          <div class="is-flex" style="font-size: 14px">
            <div class="has-text-grey-light has-text-weight-normal">DTP Query</div>
            <div class="has-text-grey-light has-text-weight-normal ml-auto">{{ getDateTime(query.queryDate) }}</div>
            <div class="ml-1 mr-1 has-text-grey-light">|</div>
            <div class="has-text-grey-light has-text-weight-normal">{{ capitalizeFirstLetter(query.queryType) }}&nbsp;&nbsp;</div>
            <div class="has-text-grey has-text-weight-normal">{{ getStageId() }}</div>
            <div v-if="getStageId() !== ''" class="ml-1">
              <b-icon v-if="getAction() === 'data'" icon="microsoft-excel" @click.native="downloadData()"
                      style="cursor: pointer"></b-icon>
              <b-icon v-if="getAction() === 'image'" icon="image" @click.native="downloadData()"
                      style="cursor: pointer"></b-icon>
              <b-icon v-if="getAction() === 'video'" icon="video-image" @click.native="downloadData()"
                      style="cursor: pointer"></b-icon>
            </div>
          </div>

          <div class="has-text-black query-field">{{ query.dtpQuery }}</div>
        </div>
        <div class="mt-3">
          <div class="is-flex" style="font-size: 14px">
            <div class="has-text-grey-light has-text-weight-normal">Response</div>
            <div class="has-text-weight-semibold ml-auto" :class="getColor()">
              {{ capitalizeFirstLetter(query.rttResponseStatus) }}&nbsp;&nbsp;
            </div>
            <div class="has-text-grey-light has-text-weight-normal">
              |&nbsp;&nbsp;{{ getUserById(query?.updatedBy)?.fullName }}&nbsp;&nbsp;
            </div>
            <div class="has-text-grey-light has-text-weight-normal">
              {{ query.rttResponseAt != null ? '|&nbsp;&nbsp;' + getDateTime(query?.rttResponseAt) : '' }}
            </div>
          </div>
          <b-field>
            <b-input type="textarea" v-model="response" @input="onResponseChanged"></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <hr class="my-divider">
  </div>
</template>

<script>
import {capitalizeFirstLetter, getDateTime} from "@/utils/utils";
import {mapActions, mapGetters} from "vuex";
import PreviewModal from "@/modules/dtp-query/components/preview-modal/preview-modal.vue";

export default {
  name: "dtp-single-query",
  components: {PreviewModal},
  mounted() {
    if (this.query && this.query.rttResponse) {
      this.response = JSON.parse(JSON.stringify(this.query.rttResponse))
    }
  },
  data() {
    return {
      response: null,
      isLoading: false
    }
  },
  methods: {
    ...mapActions({
      getFileUrl: 'dtpQueryModule/getFileUrl',
    }),

    getDateTime,
    capitalizeFirstLetter,
    async downloadData() {
      console.log('On download data: ')


      if(this.query.realitePackageId == null){
        this.showToast('Missing package id', 'is-danger')
        return
      }

      this.isLoading = true

      const response = await this.getFileUrl({
        type: this.query.queryType,
        id: this.query.realitePackageId,
        name: this.query.queryIdPart
      })
      this.isLoading = false

      if (response instanceof Error) {
        this.showToast(response.message, 'is-danger')
      } else {
        if (this.query.queryType === 'data') {
          await this.downloadFile(response, this.query.queryIdPart)
        } else if (this.$refs.previewModal) {
          await this.$refs.previewModal.show(true, response, this.query.queryType)
        }
      }
    },
    async downloadFile(presignedUrl, fileName) {
      try {
        const response = await fetch(presignedUrl);
        if (!response.ok) {
          const errorText = await response.text();
          const parser = new DOMParser();
          const xmlDoc = parser.parseFromString(errorText, "text/xml");
          const errorMessage = xmlDoc.getElementsByTagName("Message")[0]?.textContent
              || "An error occurred while downloading.";
          this.showToast(`Download failed: ${errorMessage}`, 'is-danger')
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName || 'file_download'); // Ime fajla

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.showToast('File can not be downloaded', 'is-danger')
      }
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    getAction() {
      if (this.query) {
        return this.query.queryType
      }
      return ''
    },
    getColor() {
      if (this.query && this.query.rttResponseStatus) {
        if (this.query.rttResponseStatus === 'new') {
          return 'has-text-danger'
        } else if (this.query.rttResponseStatus === 'responded') {
          return 'has-text-grey'
        } else if (this.query.rttResponseStatus === 'submitted') {
          return 'has-text-primary'
        }
      }

      return 'has-text-grey-light'
    },
    getStageId() {
      if (this.query && this.query.queryType === 'stage') {
        return `| STAGE ID: ${this.query.queryIdPart}`
      } else if (this.query && (this.query.queryType === 'video' || this.query.queryType === 'data' || this.query.queryType === 'image')) {
        return `| FILE: ${this.query.queryIdPart}`
      }

      return ''
    },
    onResponseChanged(value) {
      if (value === '') {
        this.$emit('onResponseChanged', {_id: this.query._id, response: null})
      } else {
        this.$emit('onResponseChanged', {_id: this.query._id, response: value})
      }

    },
  },
  props: {
    query: {
      type: Object,
    }
  },
  computed: {
    ...mapGetters({
      getUserById: 'getUserById'
    }),
  },
}
</script>


<style scoped lang="scss">
.query-field {
  background: #efefef;
  border-radius: 4px;
  min-height: 64px;
  padding: 8px;
  border: 1px solid #ddd;
}

.my-divider {
  border: none;
  border-top: 2px solid #eee;
  margin: 0;
}
</style>